/**
 * This module provides functions in relation to calling API routes on the backend server and processing the incoming
 * responses. The functions in this module refer to the API endpoint ApiEndPoints.EVALUATION.
 * @module
 */

import {ApiEndPoints, HttpMethods} from "../base/Settings";
import type {FetchRequest, UUID} from "../base/ui_general/GeneralInterfaces";

/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the query of evaluations
 * on the server.
 * @param transaction_id The UUID of the transaction to query evaluations for.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_get_evaluation(transaction_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.EVALUATION,
        method: HttpMethods.GET,
        query_parameters: { transaction_id: transaction_id },
    };
}